export default "__VITE_ASSET__6b7188fb__"